import React from 'react'
import "./style.scss"

export default function PrivacyPolicyPage() {
    return (
        <div className='mt-[5rem] p-[1rem] main_div' style={{ minHeight: "60vh" }} >
            <div className='first_heading_div'>
                <span className='heading_first underline  decoration-main'>Terms and Conditions</span>
            </div>

            <div className='fisrt_dec_div'>
                <div>
                    <p><strong>1. Introduction</strong></p>
                    <p>Welcome to Luxchono, the premier destination for purchasing luxury watches from renowned brands worldwide.</p>
                </div>

                <div>
                    <p><strong>2. Acceptance of Terms</strong></p>
                    <p>By accessing and using our website, you agree to be bound by these terms and conditions, our privacy policy, and any other policies or guidelines posted on this website.</p>
                </div>

                <div>
                    <p><strong>3. Product Information</strong></p>
                    <p>While we strive to provide accurate product descriptions, images, and pricing, we do not guarantee the accuracy, completeness, or reliability of any product information on our website.</p>
                </div>

                <div>
                    <p><strong>4. Ordering Process</strong></p>
                    <p>All orders placed through our website are subject to availability and acceptance. We reserve the right to refuse or cancel any order for any reason at any time.</p>
                </div>

                <div>
                    <p><strong>5. Pricing and Payment</strong></p>
                    <p>Prices for products listed on our website are in [currency] and are subject to change without notice. Payment is required at the time of placing the order. We accept various payment methods as indicated during the checkout process.</p>
                </div>

                <div>
                    <p><strong>6. Shipping and Delivery</strong></p>
                    <p>We aim to process and ship orders promptly, but delivery times may vary depending on the shipping method and location. We are not responsible for any delays or damages caused during shipping.</p>
                </div>

                <div>
                    <p><strong>7. Returns and Exchanges</strong></p>
                    <p>We do not accept returns after delivery. However, you can cancel an order and return it within 7 days of delivery for a refund. Please refer to our Returns & Exchanges Policy for detailed information on how to initiate a return or exchange.</p>
                </div>

                <div>
                    <p><strong>8. Intellectual Property</strong></p>
                    <p>All content, including text, images, logos, and trademarks, on this website is the property of Luxchono or its licensors and is protected by copyright and other intellectual property laws.</p>
                </div>

                <div>
                    <p><strong>9. Limitation of Liability</strong></p>
                    <p>In no event shall Luxchono, its officers, directors, employees, or affiliates be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in any way connected with the use of our website or the products purchased through our website.</p>
                </div>

                <div>
                    <div>
                        <p><strong>10. Governing Law</strong></p>
                        <p>These terms and conditions shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.</p>
                    </div>
                </div>

                <div>
                    <p><strong>11. Changes to Terms and Conditions</strong></p>
                    <p>We reserve the right to update or modify these terms and conditions at any time without prior notice. Your continued use of our website after any changes indicates your acceptance of the modified terms.</p>
                </div>

                <div>
                    <p><strong>12. Contact Information</strong></p>
                    <div>
                        <p><strong>12. Contact Information</strong></p>
                        <p>If you have any questions or concerns about these terms and conditions, please contact us at +91 8780529194 and luxchono@gmail.com. By using our website, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions.</p>
                    </div>
                </div>

            </div>

            <div className='secound_heading_div'>
                <span className='heading_first underline  decoration-main'>Privacy Policy</span>
            </div>

            <div className='secound_dec_div'>

                <div>
                    <p><strong>1. Introduction</strong></p>
                    <p>This Privacy Policy describes how Luxchono collects, uses, and protects the personal information you provide on our website.</p>
                </div>

                <div>
                    <p><strong>2. Information We Collect</strong></p>
                    <p>We may collect personal information such as your name, email address, shipping address, and payment details when you place an order on our website.</p>
                </div>

                <div>
                    <p><strong>3. Use of Information</strong></p>
                    <p>We use the information we collect to process your orders, communicate with you about your orders, and provide you with a personalized shopping experience. We may also use your information to improve our website and services.</p>
                </div>

                <div>
                    <p><strong>4. Security</strong></p>
                    <p>We are committed to ensuring the security of your personal information. We implement a variety of security measures to maintain the safety of your personal information when you place an order or enter, submit, or access your personal information.</p>
                </div>


                <div><p><strong>5. Cookies</strong></p>
                    <p>We use cookies to enhance your browsing experience and analyze website traffic. You can choose to accept or decline cookies. If you disable cookies, some features of our website may not function properly.</p>
                </div>


                <div>
                    <p><strong>6. Third-party Disclosure</strong></p>
                    <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as required by law or to fulfill orders.</p>
                </div>


                <div> <p><strong>7. Your Choices</strong></p>
                    <p>You can update or delete your personal information by logging into your account on our website or by contacting us directly. You may also opt-out of receiving marketing communications from us at any time.</p>
                </div>

                <div>
                    <p><strong>8. Changes to Privacy Policy</strong></p>
                    <p>We reserve the right to update or modify this Privacy Policy at any time without prior notice. Your continued use of our website after any changes indicates your acceptance of the modified policy.</p>
                </div>


                <div>
                    <p><strong>9. Contact Information</strong></p>
                    <p>If you have any questions or concerns about this Privacy Policy, please contact us at +91 8780529194 and luxchono@gmail.com.</p>
                </div>


                <div>
                    <p>By using our website, you acknowledge that you have read, understood, and agree to be bound by this Privacy Policy.</p>
                </div>

            </div>

        </div>

    )
}
